import { render, staticRenderFns } from "./HealthCheck20Register.vue?vue&type=template&id=94695c08&scoped=true&"
import script from "./HealthCheck20Register.vue?vue&type=script&lang=js&"
export * from "./HealthCheck20Register.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck20Register.vue?vue&type=style&index=0&id=94695c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94695c08",
  null
  
)

export default component.exports